<template>
  <div class="animated fadeIn">
    <br />
    <spinner v-if="loading"></spinner>
    <b-card header-tag="header" v-if="!loading">
      <b-card-body>
        <b-row v-if="!loading">
          <b-col sm="12">
            <b-alert variant="primary" show class="text-center"><h5>{{(documents && documents.length) ? 'Aqui estão seus Documentos gerados!' : 'Você ainda não gerou nenhum documento.'}}</h5></b-alert> 
          </b-col>
          <br />
          <ebook-page-box
            v-for="(document, index) in documents"
            v-bind:thumbnail="document.coverUrl"
            v-bind:fullImage="document.coverUrl"
            v-bind:watermarked="document.coverUrl"
            v-bind:key="index"
            v-bind:page="document"
            v-bind:selected="false"
            v-bind:simpleVersion="true"
            v-bind:actionText="'Ver Documento gerado em ' + (getDate(document.insertionDate))"
            v-on:page:selected="downloadDocument(document)"
            v-on:page:unselected="downloadDocument(document)"
            color="bg-secondary"
          >
            <h6></h6>
          </ebook-page-box>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import EbookPageBox from "./theme/EbookPageBox";
import service from "./../service";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import Multiselect from "vue-multiselect";
import Spinner from "./Spinner";

export default {
  name: "DocumentMine",
  props: {
    isMine: false
  },
  data: function() {
    return {
      loading: true,
      me: undefined,
      documents: []
    };
  },
  computed: {

  },
  created: function() {
    service.getMyDocuments().then(result => {
        this.documents = result.documents;
        console.log(this.documents);
        this.loading = false;
    });
  },
  methods: {
    getDate(dateStr) {
      let date = new Date(dateStr);
      return date.getDate() + "/" + (date.getMonth() + 1)  + "/" + date.getFullYear();
    },
    downloadDocument(document) {
      alert(document.finalUrl);
      window.location.href = document.finalUrl;
    }
  },
  components: { EbookPageBox, VueBootstrapTypeahead, Multiselect, Spinner }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



<style lang="css" scoped>
.background-multiSelect >>> .multiselect__tag {
  background: #20a8d8 !important;
}
.center-text {
  text-align: center !important;
}
.margin-extra {
  margin: 20px !important;
  width: unset !important;
}
</style>
